<template>
  <v-card :id="'editor-block-' + value.id" outlined class="mb-3">
    <v-card-title class="pa-2 grey lighten-4" style="cursor: move" @click="expandAndHighlight">
      <v-icon small class="mr-2 drag-handle">mdi-drag</v-icon>
      <v-chip x-small label color="primary" dark class="mr-2">{{ value.type }}</v-chip>
      <v-spacer />
      <v-btn icon x-small class="mr-1" @click.stop="$emit('move-up')">
        <v-icon small>mdi-arrow-up</v-icon>
      </v-btn>
      <v-btn icon x-small class="mr-2" @click.stop="$emit('move-down')">
        <v-icon small>mdi-arrow-down</v-icon>
      </v-btn>
      <v-btn icon x-small @click.stop="expandAndHighlight">
        <v-icon small>{{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
      <v-btn icon x-small color="error" @click.stop="$emit('remove')">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="expanded" class="pa-3">
      <v-tabs v-model="tab" dense>
        <v-tab>Content</v-tab>
        <v-tab>Style & Animation</v-tab>
      </v-tabs>
      
      <v-tabs-items v-model="tab" class="pt-4">
        <v-tab-item>
          <component
            :is="editorComponent"
            :value="value.content || {}"
            @input="updateContent"
          />
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="internalStyles.animation"
                :items="['none', 'fade-up', 'fade-down', 'fade-left', 'fade-right', 'zoom-in', 'zoom-out', 'flip-left', 'flip-right']"
                label="Entrance Animation"
                dense
                outlined
                @change="updateStyles"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="internalStyles.hoverEffect"
                :items="['none', 'lift', 'glow', 'scale', 'mouse-effect']"
                label="Hover Effect"
                dense
                outlined
                @change="updateStyles"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="internalStyles.backgroundColor"
                :items="[{text: 'Default', value: 'default'}, {text: 'Alternate (Grey)', value: 'alt'}]"
                label="Background Style"
                dense
                outlined
                @change="updateStyles"
              ></v-select>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import HeroEditor from "./editors/HeroEditor.vue";
import FeaturesEditor from "./editors/FeaturesEditor.vue";
import TrustIconsEditor from "./editors/TrustIconsEditor.vue";
import TwoColumnFeaturesEditor from "./editors/TwoColumnFeaturesEditor.vue";
import TestimonialsEditor from "./editors/TestimonialsEditor.vue";
import FaqEditor from "./editors/FaqEditor.vue";
import ContentEditor from "./editors/ContentEditor.vue";
import CtaEditor from "./editors/CtaEditor.vue";
import FormEditor from "./editors/FormEditor.vue";
import FooterEditor from "./editors/FooterEditor.vue";

var EDITOR_MAP = {
  hero: HeroEditor,
  "trust-icons": TrustIconsEditor,
  features: FeaturesEditor,
  "two-column-features": TwoColumnFeaturesEditor,
  testimonials: TestimonialsEditor,
  faq: FaqEditor,
  "content-left": ContentEditor,
  "content-right": ContentEditor,
  cta: CtaEditor,
  form: FormEditor,
  footer: FooterEditor,
};

export default {
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      expanded: false,
      tab: 0,
      internalStyles: {
        animation: 'fade-up',
        hoverEffect: 'none',
        backgroundColor: 'default',
        imageRight: false,
        ...(this.value.styles || {})
      }
    };
  },
  computed: {
    editorComponent() {
      return EDITOR_MAP[this.value.type] || null;
    },
  },
  mounted() {
    this.$root.$on("GOPAGES_EXPAND_BLOCK", this.handleExpand);
  },
  beforeDestroy() {
    this.$root.$off("GOPAGES_EXPAND_BLOCK", this.handleExpand);
  },
  methods: {
    handleExpand(id) {
      if (this.value.id === id) {
        this.expanded = true;
        console.log("Handle expand", id, this.value.id); this.$el.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        this.expanded = false; // collapse others
      }
    },
    expandAndHighlight() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        // Send message to iframe to highlight
        var iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ type: 'GOPAGES_HIGHLIGHT_BLOCK', blockId: this.value.id }, '*');
        }
      }
    },
    updateContent(content) {
      this.$emit("input", { ...this.value, content, styles: this.internalStyles });
    },
    updateStyles() {
      this.$emit("input", { ...this.value, styles: this.internalStyles });
    },
  },
};
</script>
